/// <reference lib="dom" />
// @ts-nocheck

import { FederationRuntimePlugin } from '@module-federation/enhanced';

import { getMfeOverridesManifest } from './utils';

const runtimeStore = {
  name: '',
};
const overrideManifest = getMfeOverridesManifest(
  new URLSearchParams(window.location.search).get('mfe') ?? undefined,
  window.__TEST_MFE_OVERRIDES__,
);
const localMFE = (
  Object.keys(overrideManifest).find((key) => {
    const url = overrideManifest[key] ?? '';
    return !!url.match(/local(-prod)?\.snap-dev\.net/);
  }) ?? ''
).replaceAll('-', '_');
// If there's local MFE being load, use it as the primary shared module source, otherwise use the shared module controller
const SHARED_MODULE_PRIMARY = localMFE ?? 'shared_module_controller';

/**
 * Custom federation plugin to force loading shared modules from shared module controller.
 * It overrides the resolver function of shared modules to always return from the shared module controller.
 */
function sharedModulePlugin(): FederationRuntimePlugin {
  // TODO: Should be : newer versions of MFE have a bug not exporting the type needed here so turning off type checking for now

  return {
    name: 'shared-module-plugin',

    beforeInit(args) {
      runtimeStore.name = args.options.name;

      return args;
    },

    resolveShare(args) {
      const resolver = () => {
        const { pkgName, shareScopeMap, GlobalFederation, version, scope } = args;

        // Find the shared module controller federation host
        const sharedModuleSource = GlobalFederation.__INSTANCES__.find(
          (instance) => instance.name === SHARED_MODULE_PRIMARY,
        );
        // Shared module from the shared module controller
        const sharedModuleOverride = sharedModuleSource?.options?.shared?.[pkgName]?.[0];
        // Shared module that current host requests
        const current = shareScopeMap?.[scope]?.[pkgName]?.[version];

        if (!sharedModuleOverride || !current) {
          return current;
        }

        // Find and update original instance
        const originInstance = GlobalFederation.__INSTANCES__.find(
          (instance) => instance.options.name === current.from,
        );

        // The current requested shared module is the same as the one from shared module controller
        if (current.from === sharedModuleOverride.from) {
          return current;
        }

        // Remove the current host from the useIn list of the original requested shared module
        if (originInstance?.options?.shared?.[pkgName]?.[0]) {
          originInstance.options.shared[pkgName][0].useIn = originInstance.options.shared[pkgName][0].useIn.filter(
            (i) => i !== runtimeStore.name,
          );
        }

        // Update share scope map with new instance
        if (shareScopeMap?.[scope]?.[pkgName]) {
          shareScopeMap[scope][pkgName][version] = sharedModuleOverride;
          if (!shareScopeMap[scope][pkgName][version].useIn.includes(runtimeStore.name)) {
            shareScopeMap[scope][pkgName][version].useIn.push(runtimeStore.name);
          }
        }

        return sharedModuleOverride;
      };

      return {
        ...args,
        resolver,
      };
    },
  };
}

export default sharedModulePlugin;
